import type { FaireProductEntity } from "../../entity_types/product";

export const p_rbzha5urmu: FaireProductEntity = {
  token: "p_rbzha5urmu",
  type: "product",
  name: "The Viral Dubai Cookie – Pistachio & Kataifi Indulgence",
  brandToken: "b_dkyz23ez6j",
  brandName: "Molly Bz",
  imageUrl:
    "https://cdn.faire.com/fastly/3f77d570d32cfe5535fe61da1b96d1a2e36c1a85980fc33ee478aee87203e40f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/630bdd8e92413010e49e8daf81901a8322695e5ed2405a7fdf7dec5e20d23b30.jpeg",
    "https://cdn.faire.com/fastly/f9e9c22683f25c4534901473e37fe0e3d977706d34ab25ad534709d048d93f98.jpeg",
    "https://cdn.faire.com/fastly/c53befc7a2fc4632abdd2ce76b53ab1ff939ddd597ada4f93fee5097f2271d70.jpeg",
  ],
  priceDollars: 6.91,
  description:
    "This isn't just a cookie—it's an experience. Our signature chocolate chip cookie is elevated with rich Dubai pistachio paste and delicate toasted kataifi dough, creating layers of creamy, nutty, and buttery perfection. Each bite is soft, crunchy, and luxurious… like taking a trip to Dubai's sweetest side.\n\n * ✨ Soft-baked chocolate chip cookie filled with Dubai pistachio paste \n * 🥜 Layered with golden, toasted kataifi dough for a delicate crunch \n * 🍪 Perfect balance of creamy, nutty, and sweet flavors \n * 🧊 Rich and buttery texture that melts in your mouth \n ",
  tags: [],
  msrpDollars: 13.84,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:01.067Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
